<template>
<div>
  <v-overlay :value="loading">
    <v-progress-circular indeterminate color="primary"></v-progress-circular>
  </v-overlay>
  <v-container fluid>
  <v-row class="time_period_wrap align-center">
    <span class="time_period_title pl-3">Time Period</span>
    <v-col cols="12" lg="2">
      <v-select
          v-model="timePeriodSelected"
          item-value="id"
          :items="timePeriodItems"
          solo
          dense
          hide-details
      ></v-select>
    </v-col>
    <v-col cols="12" lg="2" v-if="timePeriodSelected === 'Custom'">
      <v-menu
          ref="rangeMenu"
          v-model="rangeMenu"
          :close-on-content-click="false"
          :return-value.sync="timePeriodRange"
          transition="scale-transition"
          offset-y
          max-width="320px"
          min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
              v-model="dateRangeText"
              persistent-hint
              readonly
              prepend-inner-icon="mdi-calendar"
              v-bind="attrs"
              hide-details
              dark
              single-line
              class="pt-0 mt-0"
              label="Range"
              v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
            v-model="timePeriodRange"
            no-title
            :close-on-content-click="false"
            range
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="rangeMenu = false">Cancel</v-btn>
          <v-btn text color="primary" @click="updateRange">OK</v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>

    <v-col cols="12" lg="2" v-if="timePeriodSelected === 'Custom'" class="ml-10">
      <v-menu
              ref="rangeMenuComp"
              v-model="rangeMenuComp"
              :close-on-content-click="false"
              :return-value.sync="timePeriodRangeComp"
              transition="scale-transition"
              offset-y
              max-width="320px"
              min-width="auto"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-text-field
                  v-model="dateRangeTextComp"
                  persistent-hint
                  readonly
                  prepend-inner-icon="mdi-calendar"
                  v-bind="attrs"
                  hide-details
                  dark
                  single-line
                  class="pt-0 mt-0"
                  label="Compare to"
                  v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker
                v-model="timePeriodRangeComp"
                no-title
                :close-on-content-click="false"
                range
        >
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="clearComp">Clear</v-btn>
          <v-btn text color="primary" @click="closeComp">Cancel</v-btn>
          <v-btn text color="primary" @click="updateRangeComp">OK</v-btn>
        </v-date-picker>
      </v-menu>
    </v-col>

    <div class="timezone-menu">
      <span class="timezone-label">Time Zone</span>
      <v-autocomplete
        v-model="selectedTimezone"
        :items="filteredTimezones"
        item-value="tzCode"
        item-text="utc"
        class="timezone-select"
        dense
        hide-details
        color="white"
        @change="saveTimezone"
      ></v-autocomplete>
    </div>
    <v-spacer></v-spacer>
    <v-col cols="12" lg="2">
      <v-row align="center" class="nowrap">
        <v-text-field
            v-model="table.searchInReports"
            prepend-inner-icon="mdi-magnify"
            label="Search"
            class="text-left pt-0 mt-0"
            @input="debounceSearch"
            dark
            single-line
            hide-details
        ></v-text-field>
      <v-menu offset-y :close-on-content-click="false" v-model="columnsMenu" content-class="bg-white" min-width="380px">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mx-2" icon v-bind="attrs" v-on="on">
            <v-icon color="white">mdi-cog-outline</v-icon>
          </v-btn>
        </template>
        <v-list flat>
          <v-row>
            <v-col cols="6" sm="6">
              <v-subheader>Drilldowns</v-subheader>
              <v-list-item-group
                      v-model="table.selectedDropdowns"
                      multiple
              >
                <template v-for="header in table.drillDowns">
                  <v-list-item v-if="['drill_down', drillDown.type].indexOf(header.value) < 0" :value="header.value">
                    <template v-slot:default="{ active }">
                      <v-list-item-action class="mr-2">
                        <v-checkbox :input-value="active"></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-title>{{header.value}}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-col>
            <v-col cols="6" sm="6">
              <v-subheader>Columns</v-subheader>
              <v-list-item-group
                      v-model="table.selectedFields"
                      multiple
              >
                <template v-for="header in [...table.headers.filter(h=>h.text!=='Id')]">
                  <v-list-item v-if="['drill_down', drillDown.type].indexOf(header.value) < 0" :value="header.value">
                    <template v-slot:default="{ active }">
                      <v-list-item-action class="mr-2">
                        <v-checkbox :input-value="active"></v-checkbox>
                      </v-list-item-action>

                      <v-list-item-content>
                        <v-list-item-title>{{header.text}}</v-list-item-title>
                      </v-list-item-content>
                    </template>
                  </v-list-item>
                </template>
              </v-list-item-group>
            </v-col>
          </v-row>

        </v-list>
        <v-spacer></v-spacer>
        <div class="d-flex justify-space-between buttons-container">
          <v-btn text color="secondary" @click="columnsMenu = false">Cancel</v-btn>
          <v-btn text color="primary" @click="updateFields">OK</v-btn>
        </div>
      </v-menu>
      </v-row>
    </v-col>
  </v-row>
  </v-container>
  <template>
    <v-data-table
        dense
        :headers="tableHeaders"
        :items="getDrillDownReports[drillDown.id] ? getDrillDownReports[drillDown.id].data : []"
        :server-items-length="getDrillDownReports[drillDown.id] ? getDrillDownReports[drillDown.id].count : 0"
        :loading="table.loading"
        :footer-props="{itemsPerPageOptions: table.pageOptions}"
        :disable-sort="true"
        :item-key="`row_key_${drillDown.type}_${Date.now()}`"
        fixed-header
        :class="`elevation-1 fixed-height report-table items-size-${table.heightCounter}`"
        color="#7F98A5"
        @pagination="updateTablePagination"
        :single-expand="singleExpand"
        :expanded.sync="expanded"
        :show-expand="isShowExpand"
    >
      <!--header-->
      <template v-for="header in tableHeaders" :slot="`header.${header.value}`" slot-scope="{ header }">
        <data-filter :key="`filter-${drillDown.key}-${header.sortKey || header.value}`"
                     v-if="header.filterable === undefined || header.filterable"
                     :type="header.type || (table.calculated.indexOf(header.sortKey || header.value) > -1 ? 'range' : 'items')"
                     :min="filtersData[header.value] && table.calculated.indexOf(header.value) > -1 ? +filtersData[header.value].find(i => i.key === 'min').value : 0"
                     :max="filtersData[header.value] && table.calculated.indexOf(header.value) > -1 ? +filtersData[header.value].find(i => i.key === 'max').value : 0"
                     :items="filtersData[header.sortKey || header.value] || []"
                     :entity="header.sortKey || header.value"
                     :values="getValues(header.sortKey || header.value)"
                     @search="searchFilter"
                     @apply="applyFilter"
                     @getLazyFilters = "getLazyFilters"
                     :isLazyLoad = "true"
        />
        <a v-if="(header.sortable === undefined || header.sortable) && header.text !== 'Referer'" @click="sortColumn(header.sortKey || header.value)">
          <span class="header_title" style="text-transform: capitalize">{{header.text}}</span>
          <v-icon size="16" color="#7F98A5"> {{ (header.sortKey || header.value) === table.orderBy ? table.sortColumnsAsc ? 'mdi-arrow-up' : 'mdi-arrow-down' : 'mdi-arrow-up-down'}} </v-icon>
        </a>
        <span v-else class="header_title">{{header.text}}</span>
      </template>
      <!--/header-->
      <!--body-->
      <template v-slot:body.prepend="{items, header, expand, isExpanded}">
        <tr>
          <td class="bkg-grey" v-if="isShowExpand">
            <v-icon @click="expandAll">
              mdi-arrow-collapse-vertical
            </v-icon>
          </td>
          <td v-for="header of tableHeaders" class="text-center bkg-grey">
            <span v-if="header.value === 'drill_down'">TOTALS</span>
            <span v-else-if="headersWithoutTotals.includes(header.value)">
              -
            </span>
            <span v-else-if="['margin', 'sales_ratio', 'uvs_sales_ratio'].includes(header['value']) " class="d-block">
              {{totals[header.value] ? totals[header.value].toLocaleString("en-US") : 0}}%
              <span v-if="isShowExpand && expanded.length" class="font-weight-light d-block" >
                {{totalsComp[header.value] ? totalsComp[header.value].toLocaleString("en-US") : 0}}%
              </span>
              <span v-if="totals[header.value] && totalsComp[header.value] && isShowExpand && expanded.length" :class="(totals[header.value] >=totalsComp[header.value]) ? 'greenCol' : 'redCol'">
                {{(  (totals[header.value]/totalsComp[header.value]-1)*100  ).toFixed(2)}}%
              </span>
            </span>
            <span v-else-if="['uvs', 'clicks', 'conversions', 'total_paid', 'registrations', 'impressions', 'installations', 'sales'].includes(header['value'])" class="d-block">
              {{totals[header.value] ? totals[header.value].toLocaleString("en-US") : 0}}
              <span v-if="isShowExpand && expanded.length" class="font-weight-light d-block">
                {{totalsComp[header.value] ? totalsComp[header.value].toLocaleString("en-US") : 0}}
              </span>
              <span v-if="totals[header.value] && totalsComp[header.value] && isShowExpand && expanded.length" :class="(totals[header.value] >=totalsComp[header.value]) ? 'greenCol' : 'redCol'">
                {{(((totals[header.value]- totalsComp[header.value])/totalsComp[header.value])*100).toFixed(2)}}%
              </span>
            </span>
            <span v-else class="d-block">
              ${{totals[header.value] ? totals[header.value].toLocaleString("en-US") : 0}}
              <span v-if="isShowExpand && expanded.length" class="font-weight-light d-block">
                ${{totalsComp[header.value] ? totalsComp[header.value].toLocaleString("en-US") : 0}}
              </span>
              <span v-if="totals[header.value] && totalsComp[header.value] && isShowExpand && expanded.length" :class="(totals[header.value] >=totalsComp[header.value]) ? 'greenCol' : 'redCol'">
                {{(((totals[header.value]- totalsComp[header.value])/totalsComp[header.value])*100).toFixed(2)}}%
              </span>
            </span>
          </td>
        </tr>
      </template>
      <template v-slot:expanded-item="{ item, headers }" v-if="isShowExpand">
        <td v-for="header of headers" style="text-align: center; margin-bottom: 10px; white-space: nowrap" >
          <div v-if="!headersWithoutTotals.includes(header.value)">
            <div class="compData mt-3">
              {{
                item.comparedData && item.comparedData[header.value]
                ? item.comparedData[header.value].toLocaleString("en-US")
                : (header.value === 'drill_down' ? `${timePeriodRangeComp.join(' - ')}` : '-')
              }}
            </div>

            <span v-if="item[header.value] && item.comparedData && item.comparedData[header.value]" :class="(item[header.value] >= item.comparedData[header.value]) ? 'greenCol' : 'redCol'">
              {{(((item[header.value] - item.comparedData[header.value])/item.comparedData[header.value])*100).toFixed(2)}}%
            </span>
            <span v-if="item[header.value] && !item.comparedData[header.value]" class="greenCol">100%</span>
            <span v-if="!item[header.value] && item.comparedData[header.value]" class="redCol">-100%</span>
          </div>
        </td>
      </template>
      <template v-for="header of table.headers" :slot="`item.${[header.value]}`" slot-scope="{item}">
        <template v-if="isEntityName(header.value)">
          <a class="entity-link" @click="showCard(item)">{{item[header.value]}}</a>
        </template>
        <template v-else>{{item[header.value]}}</template>
      </template>
      <template v-slot:item.drill_down="{item}">
        <template v-for="dDown in (user[0].can('see_referrer') ? table.drillDowns: table.drillDowns.filter(dd => dd.value !== 'referer'))">
          <v-tooltip bottom v-if="isShowDrillDown(dDown, item)" :key="dDown.type">
            <template v-slot:activator="{ on, attrs }">
              <span
                  @click="addTab({
                    type: dDown.type,
                    name: dDown.name,
                    entity: drillDown.type,
                    value: dDown.value,
                    tabName: item[drillDown.value],
                    id: item[drillDown.type]
                  })"
                  v-bind="attrs"
                  v-on="on"
              >
                <v-icon size="16" class="drill_down_btn">{{dDown.icon}}</v-icon>
              </span>
            </template>
            <span>{{dDown.name}}</span>
          </v-tooltip>
        </template>
      </template>
      <template :slot="`item.${drillDown.type}`" slot-scope="{ item }">
        <template v-if="isEntityName(drillDown.value)">
          <a class="entity-link" @click="showCard(item)">{{item[drillDown.value]}}</a>
        </template>
        <template v-else>{{item[drillDown.value]}}</template>
      </template>

      <template :slot="`item.${drillDown.value}`" slot-scope="{ item }">
           {{item[drillDown.type]}}
      </template>

      <template v-if="this.platform === 2" v-slot:item.lid="{ item }">
        <a v-if="item.lid" class="entity-link"  @click="showLIDCard(item, version)">
          {{ item.lid }}
        </a>
      </template>

      <template v-slot:item.referer="{item}">
        <span style="word-break: break-all">
          {{item.referer}}
        </span>
      </template>
      <template v-slot:item.week="{ item }">
        <div style="min-width: 140px; white-space: nowrap;">
          {{ formatWeek(item.week) }}
        </div>
      </template>


      <template v-slot:item.uvs="{item}">
        {{item.uvs ? item.uvs.toLocaleString("en-US") : 0}}
      </template>
      <template v-slot:item.clicks="{item}">
        {{item.clicks ? item.clicks.toLocaleString("en-US") : 0}}
      </template>
      <template v-slot:item.impressions="{item}">
        {{item.impressions ? item.impressions.toLocaleString("en-US") : 0}}
      </template>
      <template v-slot:item.impressions="{item}">
        {{item.installations ? item.installations.toLocaleString("en-US") : 0}}
      </template>
      <template v-slot:item.impressions="{item}">
        {{item.sales ? item.sales.toLocaleString("en-US") : 0}}
      </template>
      <template v-slot:item.imp_tp="{item}">
        {{item.imp_tp ? item.imp_tp.toLocaleString("en-US") : 0}}%
      </template>
      <template v-slot:item.registrations="{item}">
        {{item.registrations ? item.registrations.toLocaleString("en-US") : 0}}
      </template>
      <template v-slot:item.reg_tp="{item}">
        {{item.reg_tp ? item.reg_tp.toLocaleString("en-US") : 0}}%
      </template>
      <template v-slot:item.conversions="{item}">
        {{item.conversions ? item.conversions.toLocaleString("en-US") : 0}}
      </template>
      <template v-slot:item.conv_tp="{item}">
        {{item.conv_tp ? item.conv_tp.toLocaleString("en-US") : 0}}%
      </template>
      <template v-slot:item.epc="{item}">
        ${{item.epc ? item.epc.toLocaleString("en-US") : 0}}
      </template>
      <template v-slot:item.avg_cost="{item}">
        ${{item.avg_cost ? item.avg_cost.toLocaleString("en-US") : 0}}
      </template>
      <template v-slot:item.cost="{item}">
          ${{item.cost ? item.cost.toLocaleString("en-US") : 0}}
      </template>
      <template v-slot:item.revenue="{item}">
          ${{item.revenue ? item.revenue.toLocaleString("en-US") : 0}}
      </template>
      <template v-slot:item.profit="{item}">
          ${{item.profit ? item.profit.toLocaleString("en-US") : 0}}
      </template>
      <template v-slot:item.margin="{item}">
        {{item.margin ? item.margin.toLocaleString("en-US") : 0}}%
      </template>
      <template v-slot:item.sales_ratio="{item}">
        {{item.sales_ratio ? item.sales_ratio.toLocaleString("en-US") : 0}}
      </template>
      <template v-slot:item.uvs_sales_ratio="{item}">
        {{item.uvs_sales_ratio ? item.uvs_sales_ratio.toLocaleString("en-US") : 0}}
      </template>
      <!--/body-->
    </v-data-table>
    <span class="updateData">
      <span class="label">Last updated: {{ value }} mins ago</span>

      <span class="version-label">Load speed:</span>

      <span v-if="speed" class="version highlight-speed mr-2">
        <v-icon small color="#1976D2" class="mr-1">mdi-database</v-icon>
        backend {{ speed }} s
      </span>

      <span v-if="totalSpeed" class="version highlight-total-speed mr-2">
        <v-icon small color="#43A047" class="mr-1">mdi-speedometer</v-icon>
        total {{ totalSpeed }} s
      </span>

      <span v-if="isFromCache" class="version from-cache mr-2">
        <v-icon small color="#FFA000" class="mr-1">mdi-memory</v-icon>
        loaded from cache
      </span>

      <v-btn icon @click="updateData">
        <v-icon color="#7F98A5">mdi-autorenew</v-icon>
      </v-btn>
    </span>



    <div style="margin-top: -60px" class="flex right">
      <v-menu v-if="table.filters.length" offset-y top :close-on-content-click="false" v-model="filtersMenu" content-class="bg-white">
        <template v-slot:activator="{ on, attrs }">
          <v-btn class="mx-2" icon v-bind="attrs" v-on="on">
            <v-icon color="secondary">mdi-filter-remove{{filtersMenu ? '' : '-outline'}}</v-icon>
          </v-btn>
        </template>
        <template>
          <v-card>
            <v-card-subtitle>Are you sure you want clear all filters?</v-card-subtitle>
            <v-card-actions>
              <v-btn text color="secondary" @click="filtersMenu = false">NO</v-btn>
              <v-spacer></v-spacer>
              <v-btn text color="error" @click="removeAllFilters">Yes</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-menu>
      <v-btn icon :disabled="table.heightCounter >= 63" @click="table.heightCounter += 3">
        <v-icon size="24" color="#7F98A5">mdi-magnify-plus-outline</v-icon>
      </v-btn>
      <v-btn icon :disabled="table.heightCounter <= 33" @click="table.heightCounter -= 3">
        <v-icon size="24"  color="#7F98A5">mdi-magnify-minus-outline</v-icon>
      </v-btn>
    </div>
  </template>
</div>
</template>

<script>
import {mapGetters, mapState} from "vuex"
import {getCookie, updateDate} from "@/helpers"
import { debounce } from 'debounce'
import DataFilter from "@/components/common/DataFilter";
import reportsApi from "@/api/reports";
import advertiosersApi from "@/api/advertisers";
import offerApi from "@/api/offer";
import campaignApi from "@/api/campaigns";
import programsApi from "@/api/programs";
import lidApi from "@/api/lid";
import store from "../../store";
import pixelLog from "@/api/pixelLog";
import affiliates from "@/api/affiliates";
import timezones from "timezones-list";
import {devs, sales} from "@/constants";


export default {
  props: {
    drillDown : Object,
    timePeriodType : String,
    timePeriod : Object,
    timePeriodComp : Object,
    additionalColumns : Array,
    isShowBlacklisted: Boolean,
    isActive: Boolean,
    version: String,
    reportType: {
      type: String,
      default: 'click'
    }
  },
  components: {
    DataFilter
  },
  data: vm=>({
    selectedTimezone: 'UTC',
    timezones,
    hasMounted: false,
    platform:null,
    reportVersion:null,
    loading: false,
    expanded: [],
    singleExpand: false,
    leftValue: 765,
    table: {
      loading: false,
      searchInReports: '',
      currentPage: 1,
      perPage: 25,
      pageOptions: [25, 50, 100, 200, 500],
      orderBy: 'clicks',
      sortColumnsAsc: false,
      userExplicitSort: false,
      heightCounter: 42,
      headers: [
        { text: 'Drill down', value: 'drill_down', align: 'center', sortable: false, filterable: false },
        { text: 'Tags', value: 'tags', align: 'left', sortable: false, filterable: false },
        { text: 'Main', value: 'main', align: 'center'},
        { text: 'UVs', value: 'uvs', align: 'center' },
        { text: 'Clicks', value: 'clicks', align: 'center' },
        // { text: 'Impressions', value: 'impressions', align: 'center' },
        // { text: 'Imp.TP', value: 'imp_tp', align: 'center' },
        { text: 'Registrations', value: 'registrations', align: 'center' },
        { text: 'Installations', value: 'installations', align: 'center' },
        { text: 'Sales', value: 'sales', align: 'center' },
        { text: 'Reg.TP', value: 'reg_tp', align: 'center' },
        { text: 'Conversions', value: 'conversions', align: 'center' },
        { text: 'Total Paid', value: 'total_paid', align: 'center' },
        // { text: 'Conv.TP', value: 'conv_tp', align: 'center' },
        { text: 'EPC', value: 'epc', align: 'center' },
        { text: 'Avg. Cost', value: 'avg_cost', align: 'center' },
        { text: 'Cost', value: 'cost', align: 'center' },
        { text: 'Revenue', value: 'revenue', align: 'center' },
        { text: 'Margin', value: 'margin', align: 'center' },
        { text: 'Profit', value: 'profit', align: 'center' },
        { text: 'Sales Ratio ‰', value: 'sales_ratio', align: 'center' },
        { text: 'U. Sales Ratio ‰', value: 'uvs_sales_ratio', align: 'center' },
        { text: 'Last Click Day', value: 'last_click_day', align: 'center', sortable: true, filterable: true, type: 'date' },
        { text: 'Last Conversion Day', value: 'last_conversion_day', align: 'center', sortable: true, filterable: true, type: 'date' },
      ],
      selectedFields: [],
      selectedDropdowns: [],
      calculated: [
         'clicks', 'conversions', 'total_paid', 'epc', 'avg_cost', 'cost', 'revenue', 'margin', 'profit', 'uvs', 'sales_ratio', 'uvs_sales_ratio'
      ],
      drillDowns: [
        {type: 'offer_id', value: 'offer', name: 'Offer', icon: 'mdi-offer'},
        {type: 'program_id', value: 'program', name: 'Program', icon: 'mdi-open-in-app'},
        {type: 'campaign_id', value: 'campaign', name: 'Campaign', icon: 'mdi-bullhorn-outline'},
        {type: 'sub_campaign', value: 'sub_campaign', name: 'Sub campaign', icon: 'mdi-bullhorn'},
        {type: 'geo', value: 'geo', name: 'Geo', icon: 'mdi-earth'},
        {type: 'day', value: 'day', name: 'Day', icon: 'mdi-calendar-today'},
        {type: 'week', value: 'week', name: 'Week', icon: 'mdi-calendar-week'},
        {type: 'hour', value: 'hour', name: 'Hour', icon: 'mdi-hours-24'},
        {type: 'isp', value: 'isp', name: 'ISP', icon: 'mdi-spider-web'},
        {type: 'affiliate_id', value: 'affiliate', name: 'Affiliate', icon: 'mdi-account'},
        {type: 'os', value: 'os', name: 'Os', icon: 'mdi-microsoft-windows-classic'},
        {type: 'device', value: 'device', name: 'Device', icon: 'mdi-cellphone-link'},
        {type: 'vertical_name', value: 'vertical_name', name: 'Verticals', icon: 'mdi-align-vertical-bottom'},
        {type: 'advertiser_id', value: 'advertiser', name: 'Advertiser', icon: 'mdi-briefcase-account'},
        {type: 'affiliate_manager_id', value: 'affiliate_manager', name: 'AM', icon: 'mdi-account-tie'},
        {type: 'advertiser_manager_id', value: 'advertiser_manager', name: 'BD', icon: 'mdi-briefcase-account'},
        {type: 'referer', value: 'referer', name: 'Referrer', icon: 'mdi-arrow-expand-right', filetrable: false, sortable: false},
        {type: 'tier', value: 'tier', name: 'Tier', icon: 'mdi-medal', filetrable: false, sortable: false},
        {type: 'highest_tier', value: 'highest_tier', name: 'Highest Tier', icon: 'mdi-medal-outline', filetrable: false, sortable: false},
        {type: 'custom', value: 'custom', name: 'Custom', icon: 'mdi-tune', filetrable: false, sortable: false},
        {type: 'img', value: 'img', name: 'Image', icon: 'mdi-image', filetrable: false, sortable: false},
        {type: 'kw', value: 'kw', name: 'KeyWord', icon: 'mdi-format-title', filetrable: false, sortable: false},
        {type: 'cid', value: 'cid', name: 'Cid', icon: 'mdi-import', filetrable: false, sortable: false},
        {type: 'lid', value: 'lid', name: 'Lid', icon: 'mdi-export', filetrable: false, sortable: false},
        {type: 'state', value: 'state', name: 'State', icon: 'mdi-earth-box', filetrable: false, sortable: false},
        {type: 'source_url', value: 'source_url', name: 'Source URL', icon: 'mdi-link-plus', filetrable: false, sortable: false},
      ],
      filters: [],
      lastSelectedFilter: ''
    },
    rangeMenu: false,
    rangeMenuComp: false,
    isCompClicked: false,
    timePeriodSelected: 'Today',
    timePeriodItems: [
      'Today',
      'Yesterday',
      'Week to date',
      'Month to date',
      'Year to day',
      'Last week',
      'Last month',
      'Last 7 days',
      'Custom'
    ],
    timePeriodRange: [new Date().toISOString().substr(0, 10), new Date().toISOString().substr(0, 10)],
    timePeriodRangeComp: ['', ''],
    interval: {},
    value: 0,
    filtersData: {},
    columnsMenu: false,
    filtersMenu: false,
    headersWithoutTotals: [
            'tags', 'offer_id', 'campaign_id', 'advertiser_id', 'affiliate_id', 'am', 'bd', 'geo', 'hour',
            'affiliate_manager_id', 'advertiser_manager_id', 'advertiser', 'affiliate', 'data-table-expand', 'isp',
            'day', 'week','os', 'device', 'sub_campaign', 'imp_tp', 'reg_tp', 'conv_tp',
            'affiliate_type','vertical_name', 'aff_id', 'referer', 'program_id', 'highest_tier', 'tier', 'custom','img','kw',
            'cid', 'lid', 'offer', 'campaign', 'program', 'advertiser', 'last_click_day', 'last_conversion_day', 'state', 'source_url'
    ],
    totals: {
      uvs: 0,
      clicks:0,
      impressions: 0,
      installations: 0,
      sales: 0,
      registrations: 0,
      conversions:0,
      total_paid:0,
      epc:0,
      revenue:0,
      margin:0,
      profit:0,
      cost: 0,
      avg_cost: 0,
      sales_ratio: 0,
      uvs_sales_ratio: 0,
    },
    totalsComp: {
      uvs: 0,
      clicks:0,
      impressions: 0,
      installations: 0,
      sales: 0,
      registrations: 0,
      conversions:0,
      total_paid:0,
      epc:0,
      revenue:0,
      margin:0,
      profit:0,
      cost: 0,
      avg_cost: 0,
      sales_ratio: 0,
      uvs_sales_ratio: 0,
    },
    copyTableHeaders: {},
    speed: 0,
    totalSpeed: 0,
    isFromCache: false,
  }),

  beforeDestroy () {
    clearInterval(this.interval)
  },

  async mounted () {
    const allowedUsers = [...devs, ...sales];
    if (this.version === 'V3' && !allowedUsers.includes(this.user[0].name)) {
      this.$router.push('/403');
      return;
    }
    if (this.version === 'V4' && !allowedUsers.includes(this.user[0].name)) {
      this.$router.push('/403');
      return;
    }

    this.loadSavedTimezone();
    // this.reportVersion = window.location.pathname.includes('V2') ? 2 : 1;
    this.reportVersion = 2;
    if (this.timePeriodType) {
      this.timePeriodSelected = this.timePeriodType;
    }
    if (this.timePeriod && this.timePeriod.from && this.timePeriod.to) {
      this.timePeriodRange = [this.timePeriod.from, this.timePeriod.to]
    }

    if (this.timePeriod && this.timePeriod.from && !this.timePeriod.to && this.timePeriodType === 'Custom') {
      this.timePeriodRange = [this.timePeriod.from, this.timePeriod.from]
    }

    this.isCompClicked = this.drillDown.breadCrumbs.length > 0 || !!(this.timePeriodComp && this.timePeriodComp.from && this.timePeriodComp.to);

    if (this.timePeriodComp && this.timePeriodComp.from && this.timePeriodComp.to) {
      this.timePeriodRangeComp = [this.timePeriodComp.from, this.timePeriodComp.to]
    }

    // todo replace this to dynamic fields feature
    const mainIndex = this.table.headers.findIndex(f => f.value === 'main');
    this.table.headers.splice(mainIndex, 1, {text: this.drillDown.name, value: this.drillDown.type, align: 'center'});

    const columnsWithIds = ['Offer', 'Campaign', 'Affiliate', 'Program', 'Advertiser'];

    if (columnsWithIds.includes(this.drillDown.name)) {
      this.table.headers.splice(mainIndex, 0, {
          text: 'Id',
          value: this.drillDown.name.toLowerCase(),
          align: 'center',
          filterable: true,
          sortable: false
      });
    }

    if (this.drillDown.value === 'affiliate') {
      if (typeof this.additionalColumns === 'undefined') {
        this.additionalColumns = [{text: 'Affiliate Type', value: 'affiliate_type', sortKey: 'affiliate_type'}]
      }
      if (this.additionalColumns?.findIndex(f => f.value === 'affiliate_type') < 0) {
        this.additionalColumns.splice(3, 0, {text: 'Affiliate Type', value: 'affiliate_type', sortKey: 'affiliate_type'})
      }
    }

    if(this.additionalColumns && this.onlyAggregatedStats) {
      for(let i = 0; i < this.additionalColumns.length; i++) {
        if (this.table.headers.map(h => h.value).includes('advertiser_id') && this.additionalColumns[i].value === 'advertiser') {
          continue;
        }
        this.table.headers.splice(3+i, 0, this.additionalColumns[i]);
      }
    }
    // remove fields from headers if user doesn't have permissions
    this.table.headers = this.table.headers.filter(
      h => !(['revenue', 'margin', 'profit'].includes(h.value) && !this.user[0].can('see_profit'))
    );

    this.table.headers = this.table.headers.filter(
            h => !(['total_paid'].includes(h.value)
                    && !(this.user[0].can('edit_campaign_ping_rate') || this.user[0].can('see_campaign_ping_rate')))
    );

    const fields = JSON.parse(localStorage.getItem(`fields-${this.drillDown.key}`));
    const dropDowns = JSON.parse(localStorage.getItem(`dropDowns-${this.drillDown.key}`));

    this.table.selectedFields = fields ? fields : this.table.headers.map(h => h.value);
    this.table.selectedDropdowns = dropDowns ? dropDowns : [];

    if (!this.onlyAggregatedStats && this.drillDown.value === 'offer') {
      this.table.headers = this.table.headers.filter(header => header.value !== 'advertiser')
    } else if (this.drillDown.value === 'offer') {
      if (!this.table.selectedFields.includes('advertiser')) {
        this.table.headers.splice(3, 0, {text: 'Advertiser', value: 'advertiser', sortKey: 'advertiser_id'})
        this.table.selectedFields.push('advertiser')
      }
    }

    if (this.drillDown.value === 'affiliate') {
      if (this.table.selectedFields.includes('advertiser')) {
        this.table.headers = this.table.headers.filter(header => header.value !== 'advertiser')
      }
      if (!this.table.selectedFields.includes('affiliate_type')) {
        this.table.headers.splice(3, 0, {text: 'Affiliate Type', value: 'affiliate_type', sortKey: 'affiliate_type'})
        this.table.selectedFields.push('affiliate_type')
      }

      if (!this.table.selectedFields.includes('aff_id')) {
        this.table.headers.splice(2, 0, {text: 'ID', value: 'aff_id', sortKey: 'aff_id'})
        this.table.selectedFields.push('aff_id')
      }
    }

    if (this.drillDown.entity === 'offer_id' && this.drillDown.name === 'Geo') {
      this.table.selectedFields = this.table.selectedFields.filter(item => item !== 'advertiser');
      this.additionalColumns = this.additionalColumns.filter(item => item.value !== 'advertiser');
    }

    this.platform = await affiliates.getPlatform()
    this.updateFiltersFromQuery();
    await this.getGeneralData();
    this.interval = setInterval(() => {
      this.value += 3
    }, 180000)
    this.hasMounted = true;
    this.speed =this.getDrillDownReports[this.drillDown.id].speed

  },

  watch: {
    reportType() {
      if (!this.hasMounted) {
        return;
      }
      this.$emit('loading-started');
      this.getGeneralData();
    },
    timePeriodSelected () {
      if (!this.hasMounted) {
        return;
      }
      this.getGeneralData()
    },
    onlyAggregatedStats() {
      if (!this.hasMounted) {
        return;
      }
      if (!this.onlyAggregatedStats && this.drillDown.value === 'offer') {
        this.table.headers = this.table.headers.filter(header => header.value !== 'advertiser')
      } else if (this.drillDown.value === 'offer') {
        this.table.headers.splice(4, 0, {text: 'Advertiser', value: 'advertiser', sortKey: 'advertiser_id'})
        this.table.selectedFields.push('advertiser')
      }
      this.getGeneralData()
    },
    isShowBlacklisted: function () {
      this.getGeneralData();
    },
    getExportCounter: function () {
      if (this.isActiveTab) {
        this.getGeneralData([], true);
      }

    },
    isActiveTab(newVal) {
      if (newVal && this.getDrillDownReports[this.drillDown.id]) {
        this.setExportReportData();
      }
    }
  },

  methods: {
    async saveTimezone() {
      try {
        // Validate timezone using Intl API
        try {
          Intl.DateTimeFormat(undefined, { timeZone: this.selectedTimezone });
        } catch (e) {
          this.selectedTimezone = 'UTC';
        }
        localStorage.setItem("selectedTimezone", this.selectedTimezone);
      } catch (error) {
        console.warn("Unable to access localStorage. Using default timezone 'UTC'.", error);
      }
      await this.getGeneralData();
    },
    loadSavedTimezone() {
      try {
        const savedTimezone = localStorage.getItem("selectedTimezone");
        if (savedTimezone) {
          // Validate timezone using Intl API (works with Etc/GMT zones)
          try {
            Intl.DateTimeFormat(undefined, { timeZone: savedTimezone });
            this.selectedTimezone = savedTimezone;
          } catch (e) {
            this.selectedTimezone = 'UTC';
          }
        } else {
          this.selectedTimezone = 'UTC';
        }
      } catch (error) {
        console.warn("Unable to access localStorage. Using default timezone 'UTC'.", error);
        this.selectedTimezone = 'UTC';
      }
    },
    expandAll() {
      if (!this.expanded.length) {
        this.expanded = this.getDrillDownReports[this.drillDown.id].data;
      } else {
        this.expanded = []
      }
    },
    isEntityName(item) {
      return ['advertiser', 'advertiser_id', 'affiliate', 'offer', 'campaign', 'program'].includes(item)
    },
    async showCard(item) {
      if (item.offer_id) {
        const offer = await offerApi.getOffer(item.offer_id);
        if (offer.type === 'aggregated'){
          window.open(`/advertisers/aggregatedOffer/${offer.id}`, '_blank');
        } else {
          window.open(`/advertisers/offerV2/${offer.id}`, '_blank');
        }
        return;
      }

      if (item.program_id) {
        const programData = await programsApi.getPrograms({
          limit: 1, page: 1, orderBy: 'id', orderDirectionAsc: true,
          filters: {id: item.program_id}
        });
        if (!programData || !programData.programs || !programData.programs.length) {
          return ;
        }
        const program = programData.programs[0];
        store.dispatch('cards/ADD', {
          type: 'program',
          title: `[${program.id}] - [${program.name}]`,
          key: `program-${program.id}`,
          data: program
        });
        return;
      }

      if (item.campaign_id) {
        const campaigns = await campaignApi.getCampaignsData({
          payload:{
            showInactiveCampaigns: true,
            filters: {id: item.campaign_id},
            orderBy: 'id',
            orderDirectionAsc: true,
            limit:1,
            page: 1
          }
        });
        if (!campaigns || !campaigns.data || !campaigns.data.length) {
          return
        }
        const campaign = campaigns.data[0];
        store.dispatch('cards/ADD', {
          type: 'campaign',
          title: `[${campaign.id}] - [${campaign.name}] : [${campaign.status}]`,
          key: `campaign-${campaign.id}`,
          data: campaign
        })

        return;
      }

      const advertiserData = await advertiosersApi.getAdvertisers({
        page:1,
        limit:1,
        orderBy: 'id',
        orderDirectionAsc: true,
        filters: {
          id: item.advertiser_id
        }
      });

      if (!advertiserData || !advertiserData.data || !advertiserData.data.length) {
        return;
      }

      const advertiser = advertiserData.data[0];

      if(item['advertiser'] || item['advertiser_id']) {
        store.dispatch('cards/ADD', {
          type: 'advertiser',
          title: advertiser.name,
          key: `advertiser-${advertiser.id}`,
          data: advertiser
        })
      } else if(item['affiliate']) {

        let filter = item.affiliate_id;
        const affiliate = await affiliates.getAffiliatesProfileCO({
          payload: {
            limit: 1,
            page: 1,
            orderBy: '',
            orderDirectionAsc: false,
            filters: {'affNameId': `${filter}`}
          }
        });

        const aff = affiliate.data[0]

        if (!aff) {
          console.error(`Affiliate ${item.data.affiliate_id} not found`);
          return;
        }
        await store.dispatch('cards/ADD', {
          type: 'affiliate',
          title: `${aff.id} - ${aff.name}`,
          key: `affiliate-${aff.id}`,
          data: {...aff }
        })
      }
    },
    formatWeek(date) {
      if (!date) return '-';
      const startDate = new Date(date);
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);
      const format = d => d.toISOString().split('T')[0];
      return `${format(startDate)}/${format(endDate)}`;
    },
    async showLIDCard({ lid }, version) {
      try {
        console.log('lid', lid);
        this.loading = true;

        const [lidInfo, pixel, sale] = await Promise.all([
          lidApi.getLidInfo(lid, version),
          pixelLog.getPixelsLogs(lid),
          pixelLog.getSaleByLid(lid)
        ]);



        let lidInfoItem= {};
        if (lidInfo && lidInfo.length > 0) {
          lidInfoItem = lidInfo[0];

          if (pixel && pixel.length > 0) {
            lidInfoItem.pixel = pixel[0];
          }

          if (sale && sale.length > 0) {
            lidInfoItem.sale = sale[0];
          }

          lidInfoItem.s2sPings = await affiliates.getPings(lidInfoItem.affiliate_id);

          console.log('pixel', lidInfoItem.pixel);
          console.log('sale', lidInfoItem.sale);
          // console.log('s2sPings', lidInfoItem.s2sPings);
        } else {
          console.log('No LID information found');
        }

        console.log('lidInfoItem', lidInfoItem);
        await store.dispatch('cards/ADD', {
          type: 'lid',
          title: `[${lid}]`,
          key: `lid-${lid}`,
          data: lidInfoItem,
          customSize: {
            width: 717,
            height: 824,
            top: 700,
            left: this.leftValue,
          },
        });

      } catch (error) {
        console.error('Error in showLIDCard:', error);
      } finally {
        this.loading = false; // Set loading to false when the method finishes
      }
    },

    debounceSearch: debounce(function (value) {
      this.table.searchInReports = value;
      this.getGeneralData();
    }, 700),
    async getGeneralData (filter = [], withOutPagination = false) {
      const start = performance.now()
      if (this.drillDown.value === 'affiliate') {
        if (typeof this.additionalColumns === 'undefined') {
          this.additionalColumns = []
          this.additionalColumns.push({text: 'Affiliate Type', value: 'affiliate_type', sortKey: 'affiliate_type'})
        }
        if (this.additionalColumns?.findIndex(f => f.value === 'affiliate_type') < 0) {
          this.additionalColumns.splice(3, 0, {text: 'Affiliate Type', value: 'affiliate_type', sortKey: 'affiliate_type'})
        }
      }
      this.table.loading = true
      this.$emit('isChartDataFetched', false);
      filter.push(...this.table.filters);
      if (this.table.searchInReports.length > 0) {
        filter.push({
          field: 'search',
          value: [this.table.searchInReports],
        })
      }
      filter.push(...this.drillDown.breadCrumbs);
      if (!this.isShowBlacklisted) {
        filter.push({ field: 'affiliate_status', value: ['active', 'suspended', 'blocked', 'inactive'] });
      }
      const datePeriod = updateDate({typeDate: this.timePeriodSelected, fromDate: this.timePeriodRange[0], toDate: this.timePeriodRange[1]});
      const datePeriodComp = (this.timePeriodRangeComp && this.timePeriodRangeComp[0] && this.timePeriodRangeComp[1])
        ? updateDate({typeDate: this.timePeriodSelected, fromDate: this.timePeriodRangeComp[0], toDate: this.timePeriodRangeComp[1]})
        : {fromDate: 0, toDate: 0};
      let additionalKeys = this.additionalColumns ? this.additionalColumns.map(ac => ac.sortKey) : null;
      let select = [...this.table.selectedFields, 'unique_visits'];
      select.splice(select.indexOf('drill_down'), 1);
      // ToDo: It's a trick. Should resolve the infinity cycle.
      if (select && select.length && select.includes('affiliate_type')) {
        select.splice(select.indexOf('affiliate_type'), 1);
      }
      let chartSelect = JSON.parse(JSON.stringify(select));
      if(
          chartSelect.indexOf('margin') === -1
          && chartSelect.indexOf('revenue') === -1
          && chartSelect.indexOf('profit') === -1
      ) {
        chartSelect.push('margin', 'revenue', 'profit');
      }

      if(this.additionalColumns) {
        for (let i = 0; i < select.length; i++) {
          const aColumn = this.additionalColumns.find(c => c.value === select[i]);
          if (aColumn) {
            select.push(aColumn.sortKey);
          }
        }
      }
      // ToDo: It's a trick. Should resolve the infinity cycle.
      if (additionalKeys && additionalKeys.indexOf('affiliate_type') >= 0) {
        select.push('affiliate_type');
      }
      if (!this.onlyAggregatedStats && additionalKeys && additionalKeys.length && additionalKeys.includes('advertiser_id')) {
        if (select && select.length && select.includes('advertiser')) {
          select.splice(select.indexOf('advertiser'), 1);
        }
        if (select && select.length && select.includes('advertiser_id')) {
          select.splice(select.indexOf('advertiser_id'), 1);
        }
        additionalKeys.splice(additionalKeys.indexOf('advertiser_id'), 1);
      }
      if (this.drillDown.value === 'affiliate' && !select.includes('affiliate_type')
          && (additionalKeys && !additionalKeys.includes('affiliate_type'))) {
        select.push('affiliate_type');
        additionalKeys.push('affiliate_type');
      }

      const keysToDelete = [];
      if (this.additionalColumns && this.additionalColumns.length > 0) {
        this.additionalColumns.forEach(col => {
          const result = chartSelect.indexOf(col.sortKey);
          if (result > 0) {
            keysToDelete.unshift(result)
          }
        })
      }
      keysToDelete.unshift(chartSelect.indexOf(this.drillDown.type));
      if(chartSelect.indexOf('aff_id') >= 0) {
        keysToDelete.unshift(chartSelect.indexOf('aff_id'));
      }

      if (keysToDelete && keysToDelete.length > 0) {
        keysToDelete.forEach(index => {
          chartSelect.splice(index, 1)
        })
      }

      if (!chartSelect.includes('day')) {
        chartSelect.push('day');
      }

      select = [...select.filter(s => !['advertiser', 'affiliate', 'offer', 'campaign', 'program'].includes(s))];
      chartSelect = [...chartSelect.filter(s => !['advertiser', 'affiliate', 'offer', 'campaign', 'program'].includes(s))];

      if (withOutPagination) {
        let groupBy = additionalKeys && additionalKeys.length ? `${this.drillDown.type},${additionalKeys.join(',')}` : this.drillDown.type;

        if (select.includes('lid') || select.includes('cid')) {
          const extraFields = [
            'campaign_id',
            'campaign',
            'affiliate_id',
            'affiliate',
            'ip',
            'click_date',
            'referrer',
            'conversion_date',
            'redirect_url',
            'sub_campaign',
            'is_fired',
            'payin',
            'payout',
          ];

          if (select.includes('lid') && !extraFields.includes('cid')) {
            extraFields.unshift('cid');
          } else if (select.includes('cid') && !extraFields.includes('lid')) {
            extraFields.unshift('lid');
          }

          for (const field of extraFields) {
            if (!select.includes(field)) {
              select.push(field);
            }

            if (!groupBy.includes(field)) {
              groupBy += `,${field}`;
            }
          }
        }

        this.table.loading = false;
        this.$emit('isChartDataFetched', true);
        this.$emit('loading-complete');
        
        this.$store.dispatch('reports/saveDrillDownReportsWithoutPagination', {
          filter: filter,
          entity: this.drillDown.value,
          groupBy: groupBy,
          select: select,
          fromDate: datePeriod.fromDate,
          toDate: datePeriod.toDate,
          fromDateComp: datePeriodComp.fromDate,
          toDateComp: datePeriodComp.toDate,
          limit: 9999,
          page: 1,
          orderBy: this.table.userExplicitSort ? this.table.orderBy : '',
          orderDirectionAsc: this.table.sortColumnsAsc,
          drillDownType: this.drillDown.value,
          id: this.drillDown.id,
          onlyAggregatedStats: this.onlyAggregatedStats,
          isCompared: true,
          isChart: false,
          platform: this.reportVersion,
          version: this.version,
          timezone: this.selectedTimezone,
          conversionFocused: this.conversionFocused,
          isExporting: true,
          exportFields: this.getExportFields,
          breakdownBy: this.getBreakdownBy
        }).then();
        return;
      }

      await Promise.all([
        this.$store.dispatch('reports/saveDrillDownReports', {
          filter: filter,
          entity: this.drillDown.value,
          groupBy: additionalKeys ? `${this.drillDown.type},${additionalKeys.join(',')}` : this.drillDown.type,
          select: select,
          fromDate: datePeriod.fromDate,
          toDate: datePeriod.toDate,
          fromDateComp: datePeriodComp.fromDate,
          toDateComp: datePeriodComp.toDate,
          limit: this.table.perPage,
          page: this.table.currentPage,
          orderBy: this.table.userExplicitSort ? this.table.orderBy : '',
          orderDirectionAsc: this.table.sortColumnsAsc,
          drillDownType: this.drillDown.value,
          id: this.drillDown.id,
          onlyAggregatedStats: this.onlyAggregatedStats,
          isCompared: true,
          isChart: false,
          platform: this.reportVersion,
          version: this.version,
          timezone: this.selectedTimezone,
          conversionFocused: this.conversionFocused
        }),
        this.$store.dispatch('reports/saveChartReport', {
          filter: filter,
          entity: this.drillDown.value,
          groupBy: `day`,
          select: chartSelect,
          fromDate: datePeriod.fromDate,
          toDate: datePeriod.toDate,
          fromDateComp: datePeriodComp.fromDate,
          toDateComp: datePeriodComp.toDate,
          limit: 99999999,
          page: 1,
          orderBy: '',
          orderDirectionAsc: this.table.sortColumnsAsc,
          drillDownType: this.drillDown.value,
          id: this.drillDown.id,
          onlyAggregatedStats: this.onlyAggregatedStats,
          isCompared: this.isCompared,
          isChart: true,
          platform: this.reportVersion,
          version: this.version,
          timezone: this.selectedTimezone,
          conversionFocused: this.conversionFocused
        })
      ]);
      this.setExportReportData();
      this.$emit('isChartDataFetched', true);

      // this.getFiltersData();
      this.expanded = this.getDrillDownReports[this.drillDown.id].data;
      const options = this.buildOptions();

      if (!options.fromDate && !options.fromDate) {
        this.rangeMenu = true;
      }
      if (!options.fromDateComp && !options.toDateComp) {
        //this.rangeMenuComp = true;
      }
      this.$emit('updateTab', this.drillDown.key, options);
      this.table.loading = false;
      this.$emit('loading-complete');

      const totals = this.getDrillDownReports[this.drillDown.id].totals;
      const totalsComp = this.getDrillDownReports[this.drillDown.id].totalsComp;

      this.totals = {
        uvs: totals.total_uvs,
        clicks: totals.total_clicks,
        impressions: totals.total_impressions,
        installations: totals.total_installations,
        sales: totals.total_sales,
        registrations: totals.total_registrations,
        conversions: totals.total_conversions,
        total_paid: totals.total_total_paid,
        epc: totals.avg_epc,
        revenue: totals.total_revenue,
        margin: totals.total_margin,
        profit:totals.total_profit,
        cost: totals.total_cost,
        avg_cost: totals.total_avg_cost,
        sales_ratio: totals.total_sales_ratio,
        uvs_sales_ratio: totals.total_uvs_sales_ratio,
      };
      this.totalsComp = {
        uvs: totalsComp.total_uvs,
        clicks: totalsComp.total_clicks,
        impressions: totalsComp.total_impressions,
        installations: totalsComp.total_installations,
        sales: totalsComp.total_sales,
        registrations: totalsComp.total_registrations,
        conversions: totalsComp.total_conversions,
        total_paid: totalsComp.total_total_paid,
        epc: totalsComp.avg_epc,
        revenue: totalsComp.total_revenue,
        margin: totalsComp.total_margin,
        profit:totalsComp.total_profit,
        cost: totalsComp.total_cost,
        avg_cost: totalsComp.total_avg_cost,
        sales_ratio: totalsComp.total_sales_ratio,
        uvs_sales_ratio: totalsComp.total_uvs_sales_ratio,
      };

      this.$emit('updateTotals', this.totals);
      this.speed = this.getDrillDownReports[this.drillDown.id]?.speed || 0
      this.isFromCache = this.getDrillDownReports[this.drillDown.id]?.isFromCache || false
      const end = performance.now()
      this.totalSpeed = ((end - start) / 1000).toFixed(2)
    },
    async getFiltersData(customHeader = null) {
      if (this.drillDown.value === 'affiliate') {
        if (typeof this.additionalColumns === 'undefined') {
          this.additionalColumns = []
          this.additionalColumns.push({text: 'Affiliate Type', value: 'affiliate_type', sortKey: 'affiliate_type'})
        }
        if (this.additionalColumns?.findIndex(f => f.value === 'affiliate_type') < 0) {
          this.additionalColumns.splice(3, 0, {text: 'Affiliate Type', value: 'affiliate_type', sortKey: 'affiliate_type'})
        }
      }
      const datePeriod = updateDate({typeDate: this.timePeriodSelected, fromDate: this.timePeriodRange[0], toDate: this.timePeriodRange[1]});
      let additionalKeys = this.additionalColumns ? this.additionalColumns.map(ac => ac.sortKey) : null;
      if (!this.onlyAggregatedStats && additionalKeys && additionalKeys.length && additionalKeys.includes('advertiser_id')) {
        additionalKeys.splice(additionalKeys.indexOf('advertiser_id'), 1);
      }
      const mapper = {
        advertiser: 'advertiser_id',
        affiliate: 'affiliate_id'
      }
      this.table.headers.forEach(header => {
        if(customHeader && customHeader !== header.value && customHeader !== mapper[header.value]) {
          return;
        }
        if (this.drillDown.value === 'offer' && !this.onlyAggregatedStats && header.sortKey === 'advertiser_id') {
          return
        }
        if(header.filterable === undefined || header.filterable) {
          let filters = [...this.table.filters];
          if((header.sortKey || header.value) === this.table.lastSelectedFilter) {
            filters = filters.filter(f => f.field !== this.table.lastSelectedFilter);
          }
          if (this.drillDown.value === 'affiliate' && (additionalKeys && !additionalKeys.includes('affiliate_type'))) {
            additionalKeys.push('affiliate_type');
          }
          reportsApi.getFilter({
            filter: filters,
            breadCrumbs: this.drillDown.breadCrumbs,
            name: header.sortKey || header.value,
            groupBy: additionalKeys ? `${this.drillDown.type},${additionalKeys.join(',')}` : this.drillDown.type,
            fromDate: datePeriod.fromDate,
            toDate: datePeriod.toDate,
            onlyAggregatedStats: this.onlyAggregatedStats,
            drillDownType: this.drillDown.value,
            searchFilter: this.table.searchInReports,
            platform: this.reportVersion,
            version: this.version,
          }).then(res => {
            this.filtersData = Object.assign({}, this.filtersData, res);
          });
        }
      });
    },
    async getLazyFilters(header){
      this.getFiltersData(header);
    },
    updateFiltersFromQuery() {
      const queryFilters = this.$route.query.filters && JSON.parse(this.$route.query.filters);
      if (queryFilters) {
        this.table.filters.push(queryFilters);
      }
    },

    buildOptions() {
      const options = {};
      options.periodType = this.timePeriodSelected;
      if (options.periodType === 'Custom') {
        options.fromDate = this.timePeriodRange[0];
        options.toDate = this.timePeriodRange[1];
        if (this.timePeriodRangeComp && this.timePeriodRangeComp[0] && this.timePeriodRangeComp[1]) {
          options.fromDateComp = this.timePeriodRangeComp[0];
          options.toDateComp = this.timePeriodRangeComp[1];
        }
      }
      return options;
    },

    getValues(entity) {
      const filter = this.table.filters.find(f => f.field === entity);
      return filter ? filter.value : undefined
    },
    camelToSnake(string) {
      return string.replace(/[\w]([A-Z])/g, function(m) {
        return m[0] + "_" + m[1];
      }).toLowerCase();
    },
    updateRange() {
      this.$refs.rangeMenu.save(this.timePeriodRange)
      this.getGeneralData()
    },
    updateRangeComp() {
      if (this.timePeriodRangeComp[0] && !this.timePeriodRangeComp[1]) {
        this.timePeriodRangeComp[1] = this.timePeriodRangeComp[0]
      }
      this.$refs.rangeMenuComp.save(this.timePeriodRangeComp)
      this.isCompClicked = true;
      this.getGeneralData()
    },
    updateFields() {
        localStorage.setItem(`fields-${this.drillDown.key}`, JSON.stringify(this.table.selectedFields));
        localStorage.setItem(`dropDowns-${this.drillDown.key}`, JSON.stringify(this.table.selectedDropdowns));
        this.columnsMenu = false;
        this.getGeneralData();
    },
    updateTablePagination(params){
      if (
          this.table.currentPage === params.page &&
          this.table.perPage === params.itemsPerPage
      ) {
        return
      }
      this.table.currentPage = params.page
      this.table.perPage = params.itemsPerPage
      this.getGeneralData()
    },
    async sortColumn(column) {
      this.table.sortColumnsAsc = this.table.orderBy === column ? !this.table.sortColumnsAsc : true;
      this.table.orderBy = this.camelToSnake(column)
      this.table.userExplicitSort = true;
      await this.getGeneralData()
    },
    updateDataInFilters(data, modalName) {

    },
    isShowDrillDown(drillDown, item) {
      if (!this.table.selectedDropdowns.map(sd => sd.toLowerCase()).includes(drillDown.value.toLowerCase())) {
        return false;
      }
      if (this.drillDown.breadCrumbs.find(bc => bc.field === drillDown.type)) {
        return false;
      }
      return drillDown.type !== this.drillDown.type;
    },
    addTab(tab) {
      tab.breadCrumbs = [];
      this.drillDown.breadCrumbs.forEach(bc => {
        if(bc.field !== tab.entity && bc.value !== tab.id) {
          tab.breadCrumbs.push(bc)
        }
      })
      tab.key = this.drillDown.key || '';
      if (tab.id && tab.entity) {
        tab.breadCrumbs.push({field: tab.entity, value: tab.id, name: tab.tabName})
      }
      tab.key += `_${tab.id}_${tab.type}`;
      const options = {};
      options.periodType = this.timePeriodSelected;
      if(options.periodType === 'Custom') {
        options.fromDate = this.timePeriodRange[0];
        options.toDate = this.timePeriodRange[1];
        options.fromDateComp = this.timePeriodRangeComp[0];
        options.toDateComp = this.timePeriodRangeComp[1];
      }
      this.$emit('goDown', tab, options)
    },
    updateData() {
      this.getGeneralData()
      this.value = 0
    },
    // new filter methods
    searchFilter(search, entity) {
      const datePeriod = updateDate({typeDate: this.timePeriodSelected, fromDate: this.timePeriodRange[0], toDate: this.timePeriodRange[1]});
      reportsApi.getFilter({
        name: entity,
        breadCrumbs: this.drillDown.breadCrumbs,
        groupBy: entity,
        fromDate: datePeriod.fromDate,
        toDate: datePeriod.toDate,
        searchFilter: search,
        platform: this.reportVersion
      }).then(res => {
        this.filtersData = Object.assign({}, this.filtersData, res);
      });
    },
    async removeAllFilters() {
      this.table.filters = [];
      this.filtersMenu = false;
      await this.getGeneralData()
    },
    async applyFilter(data, entity) {
      const filterIndex = this.table.filters.findIndex(f => f.field === entity);
      if (filterIndex >= 0) {
        if (data && data.length) {
          this.table.filters.splice(filterIndex, 1, {field: entity, value: [...data]});
        } else {
          this.table.filters.splice(filterIndex, 1);
        }
        this.table.lastSelectedFilter = this.table.filters.length ? this.table.filters[this.table.filters.length - 1].field : '';
      } else {
        if (data && data.length) {
          this.table.lastSelectedFilter = entity;
          this.table.filters.push({field: entity, value: [...data]});
        } else {
          this.table.lastSelectedFilter = '';
        }
      }

      return await this.getGeneralData()
    },
    setExportReportData() {
      const items = this.getDrillDownReports[this.drillDown.id] ? this.getDrillDownReports[this.drillDown.id].data : []

      if (!items || !items.length) {
        return this.$store.dispatch('reports/setExportReportData', {}).then();
      }
      const propsToExclude = ['campaign_id', 'offer_id', 'affiliate_id', 'tags', 'comparedData',
        'advertiser_manager_id', 'affiliate_type', 'unique_visits', 'program_id', 'advertiser_id', 'affiliate_manager_id',

      ];
      const itemToSave = {...items[0]};

      for (let prop in itemToSave) {
        if (propsToExclude.includes(prop)) {
          delete itemToSave[prop]
        }
      }
      this.$store.dispatch('reports/setExportReportData', {...itemToSave, value: this.drillDown.value}).then();
    },
    closeComp() {
      this.rangeMenuComp = false;
      this.isCompClicked = false;
    },
    clearComp() {
      this.timePeriodRangeComp = ['', ''];
      const options = this.buildOptions();
      this.$emit('updateTab', this.drillDown.key, options);

      this.rangeMenuComp = false;
      this.isCompClicked = false;
    }
  },
  computed: {
    conversionFocused() {
      return this.reportType === 'conversion';
    },
    filteredTimezones() {
      if (!timezones || !Array.isArray(timezones)) {
        console.warn("Error: Failed to load timezones");
        return [];
      }

      // Create a list of standard GMT offsets using Etc/GMT zones
      // Note: Etc/GMT zones have INVERTED signs (Etc/GMT-8 = UTC+8)
      const standardOffsets = [];
      for (let i = -12; i <= 14; i++) {
        const sign = i >= 0 ? '+' : '';
        const utcValue = `(GMT${sign}${i}:00)`;
        // Etc/GMT zones use inverted sign
        const etcSign = i <= 0 ? '+' : '-';
        const etcOffset = Math.abs(i);
        const tzCode = i === 0 ? 'UTC' : `Etc/GMT${etcSign}${etcOffset}`;
        standardOffsets.push({
          tzCode: tzCode,
          utc: utcValue,
          name: `GMT${sign}${i}`
        });
      }

      return standardOffsets;
    },
    ...mapState('user', ['user']),
    ...mapGetters('reports', ['getExportCounter']),
    isCompared () {
      const result = (
          this.timePeriodSelected === 'Custom'
          && this.timePeriodRangeComp[0] !== ''
          && this.timePeriodRangeComp[1] !== ''
      );
      this.$emit('isCompared', result);
      return result
    },
    dateRangeText () {
      return this.timePeriodRange.join(' - ')
    },
    dateRangeTextComp () {
      if(this.isCompClicked && this.timePeriodRangeComp[0] && !this.timePeriodRangeComp[1]) {
        return this.timePeriodRangeComp[0]
      }
      if(!this.isCompClicked || !this.timePeriodRangeComp[0] || !this.timePeriodRangeComp[1]) {
        return 'Compare to'
      } else {
        return this.timePeriodRangeComp.join(' - ')
      }
    },
    isShowExpand() {
      return this.timePeriodRangeComp && this.timePeriodRangeComp[0]!=='' && this.timePeriodRangeComp[1] !== '' && this.isCompClicked && this.timePeriodSelected === 'Custom';
    },
    tableHeaders() {
      const excludedFieldsForConversionReport = ['uvs', 'registrations', 'reg_tp', 'epc', 'uvs_sales_ratio', 'last_click_day'];
      let headers = this.table.headers.filter(h => this.table.selectedFields.indexOf(h.value) > -1 || h.text === 'Id');
      
      // Filter out excluded fields when in Conversion Report mode (only for platform 1)
      if (this.conversionFocused && this.platform === 1) {
        headers = headers.filter(h => !excludedFieldsForConversionReport.includes(h.value));
      }
      
      return headers;
    },
    isActiveTab() {
      return this.isActive;
    },
    ...mapGetters('reports', ['getDrillDownReports', 'getMainFilterData', 'onlyAggregatedStats', 'getExportFields', 'getBreakdownBy']),
  }
}
</script>

<style scoped lang="sass">

.timezone-menu
  display: flex
  align-items: center
  max-width: 500px
  margin-left: 0
  margin-right: auto

.timezone-label
  color: #FFFFFF
  font-size: 14px
  font-weight: 700
  margin-right: 10px

.timezone-select
  min-width: 200px
  max-width: 300px
  white-space: nowrap
  overflow: hidden
  text-overflow: ellipsis
  margin-top: -1px

.compData
  font-size: smaller
  color: var(--v-primary-base)
  display: block
.bkg-grey
  background-color: #cccccc
.greenCol
  color: #175a0c
.redCol
  color: brown
.report-table
  margin-top: 0px !important
  .v-data-table__wrapper
    height: 65.7vh
    overflow: auto
  .v-data-table-header
    th
      white-space: nowrap
.bg-white
  background-color: #fff
  z-index: 28 !important
.buttons-container
  margin-left: 10%
  margin-right: 10%
.updateData
  display: flex
  align-items: center
  gap: 8px
  font-size: 14px

.label
  color: #7f98a5

.version-label
  font-weight: 500
  color: #555
  margin-left: 8px

.version
  display: inline-flex
  align-items: center
  font-weight: bold

.highlight-speed
  color: #1976D2

.highlight-total-speed
  color: #43A047


</style>
